import { Pricing } from "@/components/ui/pricing";

const subscriptionPlans = [
  {
    name: "BASIC",
    price: "29",
    yearlyPrice: "23",
    period: "per month",
    features: [
      "Up to 500 messages/month",
      "Basic AI responses",
      "24/7 automated chat",
      "Standard support",
      "Single profile"
    ],
    description: "Perfect for individuals just starting out",
    buttonText: "Start Free Trial",
    href: "/signup",
    isPopular: false,
  },
  {
    name: "PRO",
    price: "79",
    yearlyPrice: "63",
    period: "per month",
    features: [
      "Up to 2000 messages/month",
      "Advanced AI personality",
      "Priority support",
      "Multiple profiles",
      "Custom responses",
      "Analytics dashboard",
      "API access"
    ],
    description: "Best for growing professionals",
    buttonText: "Get Started",
    href: "/signup",
    isPopular: true,
  },
  {
    name: "ENTERPRISE",
    price: "199",
    yearlyPrice: "159",
    period: "per month",
    features: [
      "Unlimited messages",
      "Custom AI training",
      "24/7 priority support",
      "Unlimited profiles",
      "Advanced analytics",
      "Custom integrations",
      "Dedicated account manager",
      "White-label solution"
    ],
    description: "For established professionals with high volume",
    buttonText: "Contact Sales",
    href: "/contact",
    isPopular: false,
  },
];

const Subscription = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-white to-pink-50">
      <Pricing 
        plans={subscriptionPlans}
        title="Choose Your HOTBOT Plan"
        description="Supercharge your business with AI-powered messaging.
Every plan includes our core features to help you succeed! 💖"
      />
    </div>
  );
};

export default Subscription;